import React from 'react';

import {
  FormControlLabel,
  Skeleton,
  Switch
} from '@mui/material';

import { FeatureName } from 'generated/graphql';
import * as dataService from './dataService';



export interface IProps {
  storeId: string;
  featureName: FeatureName;
  label: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId, props.featureName);
  const [
    toggleStoreFeature,
    toggleStoreFeatureTuple
  ] = dataService.useToggleStoreFeature(props.storeId, props.featureName);



  return (
    <FormControlLabel
      label={props.label}
      control={(
        queryTuple.loading ? (
          <Skeleton />
        ) : (
          <Switch
            disabled={queryTuple.loading || toggleStoreFeatureTuple.loading}
            checked={queryTuple.data.isEnabled}
            onChange={() =>
              toggleStoreFeature(!queryTuple.data.isEnabled)} />
        )
      )} />
  );
};
